import { faHandPointer } from '@fortawesome/pro-regular-svg-icons/faHandPointer';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons/faArrowLeft';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons/faArrowRight';
import { faBullhorn } from '@fortawesome/pro-solid-svg-icons/faBullhorn';
import { faDollarSign } from '@fortawesome/pro-solid-svg-icons/faDollarSign';
import { faShoppingBag } from '@fortawesome/pro-solid-svg-icons/faShoppingBag';
import { faUserTie } from '@fortawesome/pro-solid-svg-icons/faUserTie';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';

// Helpers
import useI18n from '@i18n';

// Graphics
import EpnAffiliateLogo from '../../../../../assets/images/affiliate/advertiser/epn-affiliate-logo.png';

// Styles
import styles from './HowItWork.module.scss';

const HowItWork: React.FC = () => {
    const { t } = useI18n('Cpa');

    return (
        <section className={styles.HowItWork}>
            <div className={styles.landingContainer}>
                <h2 className={styles.blockTitle}>
                    {t('How does e-Commerce Partners Network work?')}
                </h2>
                <div className={styles.HowItWork__items}>
                    <div className={styles.HowItWork__card}>
                        <div className={styles.HowItWork__cardTitle}>
                            {t('What do we promote? ')}
                        </div>
                        <ul
                            className={clsx([
                                styles.HowItWork__cardContent,
                                styles.HowItWork__cardContentList,
                            ])}
                        >
                            <li>• {t('Goods')}</li>
                            <li>• {t('Services')}</li>
                            <li>• {t('Games')}</li>
                            <li>• {t('Credits')}</li>
                            <li>• {t('Subscriptions')}</li>
                            <li>• {t('Your option?')}</li>
                        </ul>
                        <div className={styles.HowItWork__cardIcon}>
                            <FontAwesomeIcon icon={faBullhorn} />
                        </div>

                        <div
                            className={clsx([
                                styles.HowItWork__scheme,
                                styles.HowItWork__chanelRight,
                            ])}
                        >
                            <FontAwesomeIcon icon={faArrowRight} />
                        </div>
                    </div>

                    <div className={styles.HowItWork__card}>
                        <div className={styles.HowItWork__cardTitle}>{t('Advertiser')}</div>
                        <div className={styles.HowItWork__cardContent}>
                            {t(
                                'Looking for new channels to attract customers. Wants to increase sales and strengthen market position. Willing to pay only for results.',
                            )}
                        </div>

                        <div className={styles.HowItWork__cardIcon}>
                            <FontAwesomeIcon icon={faShoppingBag} />
                        </div>

                        <div
                            className={clsx([styles.HowItWork__scheme, styles.HowItWork__wmDollar])}
                        >
                            <FontAwesomeIcon icon={faDollarSign} />
                        </div>

                        <div className={clsx([styles.HowItWork__scheme, styles.HowItWork__wmLeft])}>
                            <FontAwesomeIcon icon={faArrowLeft} />
                        </div>

                        <div
                            className={clsx([styles.HowItWork__scheme, styles.HowItWork__wmRight])}
                        >
                            <FontAwesomeIcon icon={faArrowRight} />
                        </div>
                    </div>

                    <div className={styles.HowItWork__card}>
                        <div className={styles.HowItWork__cardTitle}>
                            {t('e-Commerce Partners Network')}
                        </div>
                        <div className={styles.HowItWork__cardContent}>
                            {t(
                                'Organizes interaction between parties. Provides access to a global audience.',
                            )}
                        </div>
                        <div className={styles.HowItWork__cardIcon} style={{ bottom: 0 }}>
                            <img src={EpnAffiliateLogo} alt="" />
                        </div>

                        <div
                            className={clsx([
                                styles.HowItWork__scheme,
                                styles.HowItWork__affiliateDollar,
                            ])}
                        >
                            <FontAwesomeIcon icon={faDollarSign} />
                        </div>

                        <div
                            className={clsx([
                                styles.HowItWork__scheme,
                                styles.HowItWork__affiliateLeft,
                            ])}
                        >
                            <FontAwesomeIcon icon={faArrowLeft} />
                        </div>

                        <div
                            className={clsx([
                                styles.HowItWork__scheme,
                                styles.HowItWork__affiliateRight,
                            ])}
                        >
                            <FontAwesomeIcon icon={faArrowRight} />
                        </div>
                    </div>

                    <div className={styles.HowItWork__card}>
                        <div className={styles.HowItWork__cardTitle}>{t('Webmaster')}</div>
                        <div className={styles.HowItWork__cardContent}>
                            {t(
                                "Uses their platforms and tools to attract customers to the advertiser's site.",
                            )}
                        </div>
                        <div className={styles.HowItWork__cardIcon}>
                            <FontAwesomeIcon icon={faUserTie} />
                        </div>
                    </div>
                </div>
                <div className={styles.HowItWork__tip}>
                    <FontAwesomeIcon icon={faHandPointer} className={styles.HowItWork__tipIcon} />
                    <span className={styles.HowItWork__tipText}>
                        {t('Scroll right to view the whole scheme')}
                    </span>
                </div>
            </div>
        </section>
    );
};

export default HowItWork;
